import { ApiErrorText, Loader } from '@/shared/components';
import { WebApiTokensContentEmptyState } from './ApiTokensContentEmptyState';
import { ApiTokenItem, type ApiToken } from '@/entities/api-token';
import type { ApiTokenAccessKey } from '@/shared/types';

type Props = {
  isApiTokensLoading: boolean;
  apiTokensError: Error | null;
  apiTokens: ApiToken[];
  onEdit: (apiToken: ApiToken) => void;
  onDelete: (webapiTokenid: string) => void;
  accessTypes: Record<ApiTokenAccessKey, string>;
};

export const ApiTokensContent = ({
  isApiTokensLoading,
  apiTokensError,
  apiTokens,
  onEdit,
  onDelete,
  accessTypes,
}: Props) => {
  if (isApiTokensLoading) {
    return (
      <div className="flex items-center justify-center h-[24.4rem]">
        <Loader />
      </div>
    );
  }

  if (apiTokensError) {
    return (
      <div className="flex items-center justify-center h-[24.4rem]">
        <ApiErrorText error={apiTokensError} />
      </div>
    );
  }

  if (!apiTokens?.length) {
    return (
      <div className="flex items-center justify-center w-full min-h-[24.4rem]">
        <WebApiTokensContentEmptyState />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[1.6rem]">
      {apiTokens.map(apiToken => (
        <ApiTokenItem
          key={apiToken.webapiTokenid}
          id={apiToken.webapiTokenid}
          authenticationType={apiToken.authenticationType}
          access={accessTypes[apiToken.access]}
          onDelete={() => onDelete(apiToken.webapiTokenid)}
          onEdit={() => onEdit(apiToken)}
        />
      ))}
    </div>
  );
};
